import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_maintenance_report = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [branches, setBranches] = useState([]);
  const storedBranch = localStorage.getItem("branch");
  const [selectedBranch, setSelectedBranch] = useState(storedBranch || "");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
   const canView  = hasPermission("Vehicle maintenance - Report", "view");

useEffect(() => {
  const fetchMainDetailsBranches = async () => {

   
    
    const updateProgress = (val) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${val}%`;
      if (text) text.innerText = `Loading... ${val}%`;
    };

    Swal.fire({
      title: "Loading Main Details",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/main_details");
      setBranches(response.data.branches || []);
      updateProgress(100);
      setTimeout(() => Swal.close(), 400);
    } catch (error) {
      console.error("Error fetching branches:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load main branches.",
      });
    }
  };
{canView && (
  fetchMainDetailsBranches()
)}
}, []);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/main_details?branch_code=${selectedBranch}`
        );
        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch) {
      fetchData();
    }
  }, [selectedBranch]);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.vehicle_code || "").toLowerCase().includes(term) ||
    String(item.vehicle_name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  
  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Maintenance Report</h2>
          <div>
            <Time />
          </div>
        </section>

        <div className="vehicle-class">
  <div>
    <p><b>Branch wise Report :</b></p>

    <select
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(e.target.value)}
            required
            className="branch-select"
          >
            <option value="">Select Branch :</option>
            {branches.map((item) => (
              <option
                key={item.branchMaster_code}
                value={item.branchMaster_code}
              >
                {item.branchMaster_name}
              </option>
            ))}
          </select>
  </div>
</div>

      
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicleName"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Vehicle Code</th>
                <th>Vehicle Name</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.branch_code}</td>
                    <td>{item.vehicle_code}</td>
                    <td>{item.vehicle_name}</td>
                    <td>
                      <Link
                        to={`/vehicle_maintanence_details1_report/${item.vehicle_code}/${item.branch_code}`}
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>1</button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}> Next</button>
        </div>

        
      </div>
    </div>
  );
};

export default Vehicle_maintenance_report;
